import CircularProgress from '@mui/material/CircularProgress';

export default function CircularLoading({width, height, color}) {
  return <CircularProgress style={{width, height, color}} />;
}
